import React from 'react';
import styled from 'styled-components';
import { recordStatisticsEvent } from '../../../../services/statistics-service';
import { Separator } from '../../../shared/sectionable/styles';
import propTypes from '../../common/prop-types';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Text = styled.p`
  margin-top: 24px;
  font: ${props => props.theme.fontWeightRegular} 16px/130% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.secondaryColor};

  & > a {
    font-weight: ${props => props.theme.fontWeightBold};
  }
`;

export default function Message({ fund }) {
  const { id, pdsFileUrl } = fund;

  const handlePDSClick = () => recordStatisticsEvent({
    event: 'fund_profile_pds_clicked',
    statisticable: 'fund',
    id,
    clicked_url: pdsFileUrl,
    page: `${window.location.pathname}#fund-fees`,
  });

  return (
    <Container>
      <Separator />
      <Text>
        Fee data has been provided by Morningstar, it may not include all costs being charged
        on your investment. For a full overview of fees charged you should review the &nbsp;
        <a href={pdsFileUrl} target="_blank" rel="noreferrer" onClick={handlePDSClick}>
          Product Disclosure Statement
        </a>
        .
      </Text>
    </Container>
  );
}

/* eslint-disable-next-line react/require-default-props */
Message.propTypes = { fund: propTypes.fund };
